export namespace SubmitItineraryErrorConstants {
  export const RIDE_LIMIT_REACHED_WITH_RIDE_TYPE: RegExp = /.*Error: (.*) ride limit exceeded for organization\. period=\[(.*)\]/;
  export const RIDE_LIMIT_REACHED: RegExp = /.*Error: Ride limit exceeded for rider\. period=\[(.*)\]/;
}
